// extracted by mini-css-extract-plugin
export var avatarContainer = "_fi-0";
export var avatarTypingWave = "_fi-i";
export var gray = "_fi-f";
export var green = "_fi-c";
export var icon = "_fi-9";
export var image = "_fi-1";
export var lg = "_fi-6";
export var md = "_fi-5";
export var presenceDot = "_fi-b";
export var red = "_fi-d";
export var sm = "_fi-4";
export var status = "_fi-a";
export var typingDot = "_fi-h";
export var typingPill = "_fi-g";
export var xl = "_fi-7";
export var xs = "_fi-3";
export var xxl = "_fi-8";
export var xxs = "_fi-2";
export var yellow = "_fi-e";